// Thirdparty
import "swiper/css";
import "swiper/css/a11y";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";

// Theme
import "@styles/index.css";

import mediaSlider from "@scripts/components/media-slider";
import mobileBar from "@scripts/components/mobile-bar";
import pageOverlay from "@scripts/components/page-overlay";
import scrollReveal from "@scripts/components/scroll-reveal";
import siteAnnouncementBar from "@scripts/components/site-announcement-bar";
import scrollTo from "@scripts/components/scroll-to";
import siteHeader from "@scripts/components/site-header";
import siteWidget from "@scripts/components/site-widget";

mediaSlider.init();
mobileBar.init();
pageOverlay.init();
if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  scrollReveal.init();
}
scrollTo.init();
siteAnnouncementBar.init();
siteHeader.init();
siteWidget.init();

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document.documentElement.classList.remove("_preload");
  }, 250);

  const setHeights = () => {
    const siteHeader = document.querySelector(".site-header");

    if (siteHeader) {
      document.documentElement.style.setProperty("--site-header-height", `${Math.ceil(siteHeader.offsetHeight)}px`);
    }
  };

  window.addEventListener("resize", setHeights);

  setHeights();
});

// Dynamically load any components based on page conditions

const pageHas = (selector) => {
  return document.querySelectorAll(selector).length;
};

const loadComponents = async () => {
  if (pageHas("[data-modal]")) {
    const { default: component } = await import(/* webpackChunkName: "components-modal" */ "@scripts/components/modal");

    component.init();
  }
};

loadComponents();
